import { avatarTone, initials } from '../avatar';
import styles from '../styles/app.module.css';

/** Decorative: the name always stands next to it. */
export function Avatar({ name, email }: { name: string; email: string }): React.JSX.Element {
  return (
    <span className={styles.avatar} data-tone={avatarTone(email)} aria-hidden="true">
      {initials(name)}
    </span>
  );
}
